import { FunctionalComponent, h } from '@stencil/core';
import { t } from '../../i18n/i18n';
import { NowInternalFlyout } from '../now-internal-flyout/now-internal-flyout';

const LanguageButton: FunctionalComponent<Pick<NowInternalFlyout, 'entries'>> = ({ entries }) => (
  <now-internal-flyout
    variant="tertiary"
    // purge-css-from-tsx-exception dw-icon-person-arms-spread
    icon="person-arms-spread"
    label={t('header.language.language')}
    flyoutId="mobile-language-flyout"
    entries={entries}
    isMobile={true}
  />
);

export default LanguageButton;
